export const PauseIcon = ({ fillRect }: { fillRect: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill={fillRect}>
            <title>Pause</title>
            <path d="M5 2h5v20H5V2ZM14 2h5v20h-5V2Z"></path>
        </svg>
    )
}
